import { Building2, Store, TrendingUp, Rocket, ArrowUpRight } from "lucide-react";

const SERVICES = [
    { icon: Building2, name: "Residential Buyers", blurb: "Apartments, villas, plots and premium residential properties." },
    { icon: Store, name: "Commercial Buyers", blurb: "Office spaces, retail and commercial properties." },
    { icon: TrendingUp, name: "Investor Enquiries", blurb: "Targeted campaigns for property and land investors." },
    { icon: Rocket, name: "Project Launches", blurb: "Generate demand for new launches, pre-launches and available inventory." },
];

export default function PropertyCategories() {
    return (
        <section
            id="categories"
            data-testid="categories-section"
            className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
                    <div className="lg:col-span-8">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="h-px w-10 bg-[#D4AF37]" />
                            <span className="overline">Services</span>
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                            Qualified buyer enquiries, <br />
                            <span className="italic text-[#D4AF37]">by category</span>.
                        </h2>
                    </div>
                    <div className="lg:col-span-4">
                        <p className="text-white/70 leading-relaxed">
                            We help real-estate businesses generate qualified buyer enquiries across every major
                            property segment — matched to the right audience and intent signals.
                        </p>
                    </div>
                </div>

                {/* Services grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="categories-grid">
                    {SERVICES.map((c, i) => (
                        <div
                            key={c.name}
                            data-testid={`category-${i}`}
                            className="hol-card p-6 flex flex-col relative overflow-hidden group"
                        >
                            <ArrowUpRight
                                size={16}
                                className="absolute top-4 right-4 text-white/20 group-hover:text-[#D4AF37] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                                strokeWidth={1.5}
                            />
                            <div className="h-12 w-12 grid place-items-center bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37]">
                                <c.icon size={22} strokeWidth={1.5} />
                            </div>
                            <h3 className="mt-6 font-serif-display text-xl leading-tight">{c.name}</h3>
                            <p className="mt-4 text-sm text-white/60 leading-relaxed flex-1">{c.blurb}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 flex items-center justify-center">
                    <a href="#lead" data-testid="categories-cta" className="btn-outline-gold">
                        Discuss a project in your category
                    </a>
                </div>
            </div>
        </section>
    );
}
